<div *ngIf="messageService.messages.length">

  <h2 i18n="@@Messages">Messages</h2>
  <button class="clear"
          (click)="messageService.clear()" i18n="@@clear">clear</button>
  <div *ngFor='let message of messageService.messages'> {{message}} </div>

</div>
